/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponse } from '../../models/profile-response';

export interface ListProfiles$Params {
  offset: number;
  limit: number;
}

export function listProfiles(http: HttpClient, rootUrl: string, params: ListProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
  const rb = new RequestBuilder(rootUrl, listProfiles.PATH, 'get');
  if (params) {
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileResponse>>;
    })
  );
}

listProfiles.PATH = '/rest/profile/{offset}/{limit}';
